/**
 * @file
 * @author gaoya10
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import toArray from 'rc-util/lib/Children/toArray';
import classNames from 'classnames';
import OutlinedRight from 'acud-icon/lib/icons/OutlinedRight';
import BreadcrumbItem from './BreadcrumbItem';
import devWarning from '../_util/devWarning';
import { ConfigContext } from '../config-provider';
import { cloneElement } from '../_util/reactNode';
// function getBreadcrumbName(route: Route, params: any) {
//     if (!route.breadcrumbName) {
//         return null;
//     }
//     const paramsKeys = Object.keys(params).join('|');
//     const name = route.breadcrumbName.replace(
//         new RegExp(`:(${paramsKeys})`, 'g'),
//         (replacement, key) => params[key] || replacement,
//     );
//     return name;
// }
// function defaultItemRender(route: Route, params: any, routes: Route[], paths: string[]) {
//     const isLastItem = routes.indexOf(route) === routes.length - 1;
//     const name = getBreadcrumbName(route, params);
//     return isLastItem ? <span>{name}</span> : <a href={`#/${paths.join('/')}`}>{name}</a>;
// }
const Breadcrumb = (_a) => {
    var { prefixCls: customizePrefixCls, separator = <OutlinedRight />, className, routes, children } = _a, 
    // itemRender = defaultItemRender,
    // params = {},
    restProps = __rest(_a, ["prefixCls", "separator", "className", "routes", "children"]);
    let crumbs;
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
    if (routes && routes.length) {
        // TODO
    }
    else if (children) {
        crumbs = toArray(children).map((element, index) => {
            if (!element) {
                return element;
            }
            if (process.env.NODE_ENV !== "production")
                devWarning(element.type && (element.type.__ACUD_BREADCRUMB_ITEM === true), 'Breadcrumb', "Only accepts Breadcrumb.Item and Breadcrumb.Separator as it's children");
            return cloneElement(element, {
                separator,
                key: index,
            });
        });
    }
    const breadcrumbClassName = classNames(prefixCls, className, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
    });
    return (<div className={breadcrumbClassName} {...restProps}>
            {crumbs}
        </div>);
};
Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;
